const bankData = [
  {
    id: "1",
    accountNo: "0526-79010777-03",
    bankName: "bank asia",
    branchCode: "0526 (Bahadurabad Branch, Karachi)",
    iban: "PK66HABB0005267901077703",
    swift: "HABBPKKA",
  },
  {
    id: "2",
    accountNo: "0526-79010777-03",
    bankName: "hsbc",
    branchCode: "0526 (Bahadurabad Branch, Karachi)",
    iban: "PK66HABB0005267901077703",
    swift: "HABBPKKA",
  },
  {
    id: "3",
    accountNo: "0526-79010777-03",
    bankName: "islamic bank bangladesh",
    branchCode: "0526 (Bahadurabad Branch, Karachi)",
    iban: "PK66HABB0005267901077703",
    swift: "HABBPKKA",
  },
  {
    id: "4",
    accountNo: "0526-79010777-03",
    bankName: "al-arafa islamic bank ltd",
    branchCode: "0526 (Bahadurabad Branch, Karachi)",
    iban: "PK66HABB0005267901077703",
    swift: "HABBPKKA",
  },
  {
    id: "5",
    accountNo: "0526-79010777-03",
    bankName: "city bank ltd",
    branchCode: "0526 (Bahadurabad Branch, Karachi)",
    iban: "PK66HABB0005267901077703",
    swift: "HABBPKKA",
  },
  {
    id: "6",
    accountNo: "0526-79010777-03",
    bankName: "standard charted bank ltd",
    branchCode: "0526 (Bahadurabad Branch, Karachi)",
    iban: "PK66HABB0005267901077703",
    swift: "HABBPKKA",
  },
];

export default bankData;
